// Copyright (c) Ensho Health, 2021 to present

export const APP_ID = 'ai.ensho.compass';

export const ROUTES = {
  HOME: '/',
  LOGIN: '/login',
  WELCOME: '/welcome',
  LOGIN_CALLBACK: '/login/callback',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password',
  RESULT_LIST: '/result/list',
  PATIENT_RESULT: '/patient/:patientId/result/:resultId',
  USER_SETUP: '/user-setup',
  ALGORITHMS: '/algorithms',
  ALGORITHMS_INFO: '/algorithms/info/:algoName',
  REQUISITION: '/requisition/:algoName?/:eid?'
};

export const LOCAL_STORAGE = {
  LOGIN_REDIRECT: 'loginRedirect',
  RSA_KEY_HAS_BEEN_STORED: `${APP_ID}-rsa-key-stored`,
  OKTA_REFERRER: `referrerPath`
};

// TODO: This data should be pulled from the API
export const ALGORITHMS = [
  {
    value: 'CA_4F',
    name: 'CA-4F',
    fullName: 'Transthyretin Amyloid Cardiomyopathy (ATTR-CM, CA-4F)',
    shortName: 'ATTR-CM',
    diseaseName: 'Transthyretin Amyloid Cardiomyopathy',
    reportVersion: '1.0',
    cardContent:
      'Estimates the pre-test probability of transthyretin amyloid cardiomyopathy based on four sets of data extracted from echocardiograms and electrocardiograms',
    cdlService: 'CA4F',
    isSponsored: true,
    isActive: true,
    singleRecord: false,
    wholeDatabase: true
  },
  {
    value: 'MND_5',
    name: 'MNd-5',
    fullName: 'Amyotrophic Lateral Sclerosis (ALS)',
    shortName: 'ALS',
    diseaseName: 'Amyotrophic Lateral Sclerosis',
    reportVersion: '1.0',
    cardContent: 'Estimates the pre-test probability of MNd-5',
    cdlService: 'MND5',
    isSponsored: true,
    isActive: true,
    singleRecord: false,
    wholeDatabase: true
  },
  {
    value: 'RS005',
    name: 'TAK-675-5002',
    fullName: 'TAK-675-5002 (RS005)',
    shortName: '',
    diseaseName: '',
    reportVersion: '1.0',
    cardContent: '',
    cdlService: 'RS005',
    isSponsored: true,
    isActive: true,
    singleRecord: true,
    wholeDatabase: true
  }
  // {
  //   value: 'SD_9',
  //   name: 'SD-9',
  //   fullName: "Still's Disease (AOSD, SD-9)",
  //   shortName: 'AOSD',
  //   diseaseName: "Adult Onset Still's Disease",
  //   reportVersion: '1.0',
  //   cardContent:
  //     "Identifies individuals the probability of Still's and related IL-1 mediated autoinflammatory diseases in patients with a history of fever",
  //   cdlService: 'SD9',
  //   isSponsored: true,
  //   isActive: true,
  //   singleRecord: true,
  //   wholeDatabase: false
  // }
  // {
  //   value: 'MY14',
  //   name: 'MY-14',
  //   fullName: 'Amyotrophic Lateral Sclerosis (ALS, MY-14)',
  //   shortName: 'ALS',
  //   diseaseName: 'Amyotrophic Lateral Sclerosis',
  //   reportVersion: '1.0',
  //   cardContent: 'Estimates the probability of amyotrophic lateral sclerosis based on clinical and electromyography findings',
  //   cdlService: 'MY14',
  //   isSponsored: true,
  //   isActive: true,
  //   singleRecord: true,
  //   wholeDatabase: false
  // },
  // {
  //   value: 'HFA_H2F',
  //   name: 'HFA-H2F'
  //   fullName: 'Heart Failure with Preserved Ejection Fraction (HFpEF, HFA-PEFF + H2FPEF)',
  //   shortName: 'HFpEF, HFA-PEFF + H2FPEF'
  //   diseaseName: 'Heart Failure with Preserved Ejection Fraction',
  //   reportVersion: '1.0',
  //   cardContent: 'Applies the H2FPEF and HFA-PEFF algorithms to screen for patients with unexplained dyspnea suitable to clinical evaluation for heart failure with preserved ejection fraction',
  //   cdlService: 'HFAH2F',
  //   isSponsored: true,
  //   isActive: true,
  //   singleRecord: true,
  //   wholeDatabase: false
  // },
  // {
  //   value: 'KFRE',
  //   name: 'KFRE',
  //   fullName: 'Kidney Failure Risk Equation (KFRE)',
  //   shortName: 'KFRE',
  //   diseaseName: 'Kidney Failure Risk Equation',
  //   reportVersion: '1.0',
  //   cardContent: 'Applies the four-variable and six-variable kidney failure risk equations to predict three-year and five-year risk of kidney failure',
  //   cdlService: 'KFRE',
  //   isSponsored: true,
  //   isActive: true,
  //   singleRecord: true,
  //   wholeDatabase: false
  // }
];

export const ACTIVE_ALGORITHMS = ALGORITHMS.filter((result) => result.isActive);

export const recoveryQuestions = [
  'What is the food you least liked as a child?',
  'What is the name of your first stuffed animal?',
  'What did you earn your first medal or award for?',
  'What is your favorite security question?',
  'What is the toy/stuffed animal you liked the most as a kid?',
  'What was the first computer game you played?',
  'What is your favorite movie quote?',
  'What was the mascot of the first sports team you played on?',
  'What music album or song did you first purchase?',
  'What is your favorite piece of art?',
  "What was your grandmother's favorite dessert?",
  'What was the first thing you learned to cook?',
  'What was your dream job as a child?',
  'Where did you meet your spouse/significant other?',
  'Where did you go for your favorite vacation?',
  "Where were you on New Year's Eve in the year 2000?",
  'Who is your favorite speaker/orator?',
  'Who is your favorite book/movie character?',
  'Who is your favorite sports player?'
];

export const HELP_CODES = {
  FORGOTTEN_SITE_KEY: 'FORGOTTEN_SITE_KEY',
  FORGOTTEN_SECURITY_QUESTION: 'FORGOTTEN_SECURITY_QUESTION'
};

export const ENSHO_COLORS = {
  BLUE: {
    LINK: '#137CBD'
  },
  GRAY: {
    DISABLED: 'rgba(0, 0, 0, 0.2)',
    PALE: 'rgba(0, 0, 0, 0.1)',
    MENU_HOVER: 'rgba(167, 182, 194, 0.3)',
    REFERENCE: '#7F7F7F',
    EVIDENCE: '#182026'
  },
  WHITE: {
    TEXT: 'rgb(239, 239, 239)',
    OVERLAY: 'rgba(255,255,255,0.8)'
  },
  RED: {
    ERROR: '#DB3737'
  },
  GREEN: {
    BUTTON: '#00BF98'
  },
  BACKGROUND: '#f6f6f6'
};

// this mapping can be found in the trials_criteria table
// this list should be completed when adding more labs
export const REFERENCE_LABELS = {
  'RF.cardiac_heart.failure': 'Heart failure with preserved ejection fraction',
  'RF.cardiac_lvef': 'Heart failure with preserved ejection fraction',
  'RF.diuretics': 'Heart failure with preserved ejection fraction',
  'RF.events_HHF': 'Heart failure with preserved ejection fraction',
  'RF.hospital_HHF': 'Heart failure with preserved ejection fraction',
  'RF.cardiac_atrial.fibrillation': 'Atrial fibrillation',
  'RF.cardiac_conductionabn': 'Conduction abnormalities',
  'RF.cardiac_vent.arrhythmia': 'Ventricular arrhythmias',
  'RF.cardiac_lowflow-aortic-stenosis': 'Aortic stenosis',
  'RF.auto_orthostatic.hypotension': 'Orthostatic hypotension',
  'RF.auto_gastroparesis': 'Gastroparesis',
  'RF.auto_sexual': 'Sexual dysfunction',
  'RF.auto_sweating': 'Sweating abnormalities',
  'RF.neuro_neuropathy': 'Peripheral sensorimotor neuropathy',
  'RF.neuro_carpal.tunnel': 'Carpal tunnel syndrome',
  'RF.neuro_lumbar.stenosis': 'Lumbar spinal stenosis',
  'RF.MSK_muscle.weakness': 'Muscle weakness',
  'RF.MSK_arthropathy': 'Arthropathy',
  'RF.MSK_fatigue': 'Fatigue',
  'RF.MSK_cachexia': 'Unexplained weight loss',
  'RF.MSK_biceps': 'Biceps tendon rupture',
  'RF.GI_liverenzymes': 'Elevated liver enzymes',
  'RF.GI_symptoms': 'Nausea, constipation, early satiety, bloating',
  'RF.ocular': 'Vitreous opacities',
  'RF.renal_ckd': 'Mild renal insufficiency',
  'RF.renal_gfr': 'Mild renal insufficiency',
  'RF.nonttr_flags': 'Findings consistent with other forms of amyloidosis',
  'RF.exclusions': 'Findings not consistent with ATTR-CM',
  'RF.HCM': 'Findings not consistent with ATTR-CM',
  ttr_amyloid: 'Previously investigated for ATTR-CM ',
  'RF.ttr_testing': 'Results of previous investigations for ATTR-CM'
};
